import React, { FC } from 'react'
import { Box } from '@material-ui/core'
import { Tag } from 'Models/Tag/@types';
import TagChip, { TagChipProps } from './TagChip';

export interface TagsListProps extends Omit<TagChipProps, 'tag'> {
    list: Tag[];
}

const TagsList: FC<TagsListProps> = (props) => {
    const { list, ...chipProps } = props;
    return (
        <Box display={'flex'} flexDirection={'row'} flexWrap={'wrap'} justifyContent={'fle'} >
            {
                list.map((item) => {
                    return <Box key={item.id} mr={0.5} mb={0.5} ><TagChip tag={item} {...chipProps} /></Box>
                })
            }
        </Box>
    )
}

export default TagsList